import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, provide } from 'vue';

import { HelperViewStatus } from '@warrenbrasil/nebraska-web';
import { AboutStrategy } from './components/AboutStrategy';
import { TechnicalDetails } from './components/TechnicalDetails';
import { AboutLinks } from './components/AboutLinks';

import {
  getPortfolioAbout,
  PortfolioAboutData
} from '@/modules/wealth/services/portfolio';
import { PaidEventsConfigurationModal } from './components/PaidEvents/components/PaidEventsConfigurationModal';
interface Props {
  portfolioId: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'About',
  props: {
    portfolioId: null
  },
  setup(__props: any) {

const props = __props as {
  portfolioId: string;
};



const isLoading = ref(true);
const hasError = ref(false);
const aboutData = ref<PortfolioAboutData | null>(null);
const isConfigurationModalOpen = ref(false);

const getAboutData = async () => {
  isLoading.value = true;
  hasError.value = false;
  try {
    const data = await getPortfolioAbout(props.portfolioId);

    aboutData.value = data.about;
  } catch {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
};

const toogleConfigurationModal = () => {
  isConfigurationModalOpen.value = !isConfigurationModalOpen.value;
};

provide('getAboutData', getAboutData);

onMounted(async () => {
  await getAboutData();
});

return { __sfc: true,props, isLoading, hasError, aboutData, isConfigurationModalOpen, getAboutData, toogleConfigurationModal, HelperViewStatus, AboutStrategy, TechnicalDetails, AboutLinks, PaidEventsConfigurationModal }
}

})